import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { UploadScreenInfo } from 'src/app/shared/components/atoms/file-upload-component/model/file-uplaod.interface';
import { loadFileTaxInformation, resetFileTaxInformation } from '../actions/upload-file-tax-information.actions';
import { UploadScreenTaxInfo } from 'src/app/pages/tax-validation/model/tax-validation';

const initialState: UploadScreenTaxInfo = {
  fileFrontCI: undefined,
  fileBackCI: undefined,
  ciValidationRequired: false,
};
const getUploadFileTaxState = createFeatureSelector<UploadScreenTaxInfo>('UploadFileTaxInfo');
export const getUploadTaxFile = createSelector(getUploadFileTaxState, (state) => state);
export const uploadFileTaxReducer = createReducer<UploadScreenTaxInfo>(
  initialState,
  on(loadFileTaxInformation, (state, props): UploadScreenTaxInfo => ({ ...state, ...props.uploadFileTaxInfo })),
  on(resetFileTaxInformation, () => initialState),
);
